import type { Circle as LeafletCircle, CircleMarker as LeafletCircleMarker } from '@anlan/gs-map';
import type { ReactNode } from 'react';
import type { PathProps } from './path';

export interface CircleMarkerProps extends PathProps {
    center: Parameters<LeafletCircleMarker['setLatLng']>[0]
    radius?: number
    children?: ReactNode
}

export interface CircleProps extends CircleMarkerProps {}

export function updateCircle<P extends CircleMarkerProps | CircleProps>(
    layer: LeafletCircle | LeafletCircleMarker,
    props: P,
    prevProps: P
) {
    if (props.center !== prevProps.center) {
        layer.setLatLng(props.center);
    }
    if (props.radius != null && props.radius !== prevProps.radius) {
        layer.setRadius(props.radius);
    }
}
